import * as fromDatatype from '../datatype-library/index';
import * as fromDataype from "../datatype-library";

export interface app_login_provider_app_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  provider_code: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_login_provider_app_hdr_RowClass implements app_login_provider_app_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  provider_code: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


